import type { SVGProps } from 'react';

const SvgDoubleArrowDownLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M18 12L12 18L6 12' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M18 6L12 12L6 6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgDoubleArrowDownLt;
